import type {PreviewCtaComponentProps} from '@cohort/merchants/apps';
import ActionCtaPreview from '@cohort/merchants/apps/common/ActionCtaPreview';
import type {TikTokKeywordInDescriptionTriggerStruct} from '@cohort/shared/apps/tiktok/triggers/keywordInDescription';
import {useTranslation} from 'react-i18next';

const TiktokKeywordInDescriptionTriggerActionCtaComponentPreview: React.FC<
  PreviewCtaComponentProps<TikTokKeywordInDescriptionTriggerStruct>
> = ({localizationConfig}) => {
  const {t} = useTranslation('app-tiktok', {
    keyPrefix: 'triggers.keyword-in-description',
    lng: localizationConfig.desiredLanguage,
  });
  return <ActionCtaPreview text={t('ctaTitle')} withRefresh />;
};

export default TiktokKeywordInDescriptionTriggerActionCtaComponentPreview;
